import {
  VehicleInsurance,
  VehicleInsuranceEditFormValues,
  VehicleInsuranceRow,
} from "./types";


/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE INSURANCE
-----------------------------------------------------------------------------------------*/

export const transformVehicleInsurance = (
  res: any
): VehicleInsurance => {
  return {
    id: res.id,
    fromKw: res.fromKw,
    toKw: res.toKw,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE INSURANCE SEARCH
-----------------------------------------------------------------------------------------*/

export const transformVehicleInsuranceRow = (
  res: any
): VehicleInsuranceRow => {
  return {
    id: res.id,
    fromKw: res.fromKw,
    toKw: res.toKw,
    price: res.price,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION VEHICLE INSURANCE CREATE
  -----------------------------------------------------------------------------------------*/

export const transformVehicleInsuranceOnCreate = (
  formValues: VehicleInsuranceEditFormValues
): any => ({
  fromKw: formValues.fromKw,
  toKw: formValues.toKw,
  price: formValues.price,
});

/*---------------------------------------------------------------------------------------
  CALCULATION VEHICLE INSURANCE EDIT
-----------------------------------------------------------------------------------------*/

export const transformVehicleInsuranceOnUpdate = (
  formValues: VehicleInsuranceEditFormValues
): any => ({
  id: formValues.id,
  fromKw: formValues.fromKw,
  toKw: formValues.toKw,
  price: formValues.price,
});

